import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { JobOwnershipTemplate, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './job-ownership-template.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class JobOwnershipTemplateComponent extends RepositoryModal<JobOwnershipTemplate> {}
